import { Box } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import Custom3dContainer from './Custom3dContainer';

const Custom3dWrapper = (props: any) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setVisible(entry.isIntersecting),
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => {
      if (ref.current) observer.unobserve(ref.current);
    };
  }, []);

  return (
    <Box ref={ref} sx={{ width: '100%', height: '100%' }}>
      {visible && <Custom3dContainer {...props} />}
    </Box>
  );
};
export default Custom3dWrapper;
